import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Collapse from 'react-bootstrap/lib/Collapse';
import ItemWrapper from './ItemWrapper';
import Title from './Title';
import {TPSlider} from 'components/FormComponents';
import {timestampFormat} from 'utils/DateTimeHelper';
import {formatDay24Hour} from 'lib/helpers/globalize-helper';
import {formatDurationTime} from 'helpers/commonHelper';

class FlightTimes extends Component {
  state = {
    show: true
  };

  toggleFilter = () => this.setState((prevState) => ({show: !prevState.show}));

  render() {
    const {show} = this.state;
    const {
      times, type, updateFlightTimeValue, resetFlightTimeValue, translations, onTimeChange, onDurationChange
    } = this.props;
    const {depFlightTimes, retFlightTimes, departure, reset, flightLanding, flightDuration} = translations;
    const isObTimes = type === 'departure';
    const storeProp = isObTimes ? 'obTimes' : 'ibTimes';
    const title = isObTimes ? depFlightTimes : retFlightTimes;

    return (
      <ItemWrapper>
        <Title title={title} isOpen={show} onClick={this.toggleFilter} />
        <Collapse in={show}>
          <div className="filter-content">
            <TPSlider
              withIndicators={true}
              type={'range'}
              label={departure}
              resetBtn={{
                displayReset: Boolean(
                  times.departure.value[0] > times.departure.min
                  || times.departure.value[1] < times.departure.max
                ),
                resetLabel: reset,
                onReset: resetFlightTimeValue(storeProp, 'departure')
              }}
              min={times.departure.min}
              max={times.departure.max}
              allowCross={false}
              marks={{
                [times.departure.min]:
                  <span>{formatDay24Hour(timestampFormat(times.departure.value[0]))}</span>,
                [times.departure.max]:
                  <span>{formatDay24Hour(timestampFormat(times.departure.value[1]))}</span>
              }}
              onChange={updateFlightTimeValue(storeProp, 'departure')}
              value={[...times.departure.value]}
              onAfterChange={onTimeChange}
            />

            <TPSlider
              withIndicators={true}
              type={'range'}
              label={flightLanding}
              resetBtn={{
                displayReset: Boolean(
                  times.arrival.value[0] > times.arrival.min
                  || times.arrival.value[1] < times.arrival.max
                ),
                resetLabel: reset,
                onReset: resetFlightTimeValue(storeProp, 'arrival')
              }}
              min={times.arrival.min}
              max={times.arrival.max}
              allowCross={false}
              marks={{
                [times.arrival.min]:
                  <span>{formatDay24Hour(timestampFormat(times.arrival.value[0]))}</span>,
                [times.arrival.max]:
                  <span>{formatDay24Hour(timestampFormat(times.arrival.value[1]))}</span>
              }}
              onChange={updateFlightTimeValue(storeProp, 'arrival')}
              value={[...times.arrival.value]}
              onAfterChange={onTimeChange}
            />

            <TPSlider
              withIndicators={true}
              label={flightDuration}
              resetBtn={{
                displayReset: Boolean(times.duration.value < times.duration.max),
                resetLabel: reset,
                onReset: resetFlightTimeValue(storeProp, 'duration')
              }}
              min={times.duration.min}
              max={times.duration.max}
              marks={{
                [times.duration.max]: <span>{formatDurationTime(times.duration.value * 60)}</span>
              }}
              onChange={updateFlightTimeValue(storeProp, 'duration')}
              value={times.duration.value}
              onAfterChange={onDurationChange}
            />

          </div>
        </Collapse>
      </ItemWrapper>
    );
  }
}

FlightTimes.propTypes = {
  type: PropTypes.string.isRequired,
  times: PropTypes.shape({
    departure: PropTypes.shape({
      min: PropTypes.number.isRequired,
      max: PropTypes.number.isRequired,
      value: PropTypes.object.isRequired
    }),
    arrival: PropTypes.shape({
      min: PropTypes.number.isRequired,
      max: PropTypes.number.isRequired,
      value: PropTypes.object.isRequired
    }),
    duration: PropTypes.shape({
      min: PropTypes.number.isRequired,
      max: PropTypes.number.isRequired,
      value: PropTypes.number.isRequired
    })
  }),
  updateFlightTimeValue: PropTypes.func.isRequired,
  resetFlightTimeValue: PropTypes.func.isRequired,
  onTimeChange: PropTypes.func.isRequired,
  onDurationChange: PropTypes.func.isRequired,
  translations: PropTypes.shape({
    retFlightTimes: PropTypes.string.isRequired,
    flightLanding: PropTypes.string.isRequired,
    flightDuration: PropTypes.string.isRequired,
    depFlightTimes: PropTypes.string.isRequired,
    departure: PropTypes.string.isRequired,
    reset: PropTypes.string.isRequired
  })
};

export default FlightTimes;
